module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido-aebba98a1fc3f4f26e4e65ffe6986196.jpg";